// extracted by mini-css-extract-plugin
export default {"titleSection":"Contact_titleSection__xF9Sd","contactInfoSection":"Contact_contactInfoSection__lHe5O","lightText":"Contact_lightText__oCtlV","mapStyle":"Contact_mapStyle__CTLGm"};